var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9999 6.64984C5.88324 6.64984 5.7709 6.63317 5.6629 6.59984C5.55424 6.5665 5.45824 6.49984 5.3749 6.39984L0.849902 1.89984C0.716569 1.74984 0.649902 1.57484 0.649902 1.37484C0.649902 1.17484 0.724902 0.999838 0.874902 0.849838C1.0249 0.716505 1.1999 0.649838 1.3999 0.649838C1.5999 0.649838 1.7749 0.716505 1.9249 0.849838L5.9999 4.92484L10.0999 0.849838C10.2332 0.699838 10.3999 0.628838 10.5999 0.636838C10.7999 0.645505 10.9749 0.716505 11.1249 0.849838C11.2749 0.999838 11.3499 1.17884 11.3499 1.38684C11.3499 1.5955 11.2749 1.7665 11.1249 1.89984L6.6249 6.39984C6.54157 6.49984 6.4459 6.5665 6.3379 6.59984C6.22924 6.63317 6.11657 6.64984 5.9999 6.64984Z",
    fill: "#038E83"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.f73b4dd1.svg";
export { ForwardRef as ReactComponent };